export default __webpack_public_path__ + "static/Barn-Demolition-7eb06039fda33c305bb7e3f32e8177ea.jpg";